import {Authenticated} from './middleware'

export default [

  {
    name: 'session.index',
    path: '/',
    redirect: { name: 'session.create' },
    component: () => import ('../../views/cpanel/session'),
    meta: {
      title: 'Сессии',
      back: 'cpanel.dashboard',
      middleware: Authenticated
    },
    children: [
      {
        name: 'session.create',
        path: 'create',
        component: () => import ('../../views/cpanel/session/Create'),
        meta: {
          title: 'Новая сессия',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      },
      {
        name: 'session.card',
        path: 'card',
        component: () => import ('../../views/cpanel/session/Card'),
        meta: {
          title: 'Карточка клиента',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      },
      {
        name: 'session.questionnaire',
        path: 'questionnaire',
        component: () => import ('../../views/cpanel/session/Questionnaire'),
        meta: {
          title: 'Анкета',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      },

      {
        name: 'session.device',
        path: 'device',
        component: () => import ('../../views/cpanel/session/Devices'),
        meta: {
          title: 'Приборы',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      },
      {
        name: 'session.close',
        path: 'close',
        component: () => import ('../../views/cpanel/session/Close'),
        meta: {
          title: 'Заключение',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        }
      }
    ]
  },


];
